module.exports = __webpack_public_path__ + "img/NXT.10a87c07.svg";